// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__MDXUE","topDesktop":"layout_topDesktop__3TV6L","topMobile":"layout_topMobile__27rXn","footer":"layout_footer__3pflg"};